import { CompaniesInfiniteSelectField } from '@/components/_common';
import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import getInventoryReasons from '@/core/domain/inventory/inventories/getInventoriesReasons';
import getInventoryStatus from '@/core/domain/inventory/inventories/getInventoriesStatus';
import { InventoryFilterProps } from '@/core/domain/inventory/inventories/Inventory.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Col, DatePicker, Form, Row, Select } from 'antd';
import moment from 'moment';
import { useIntl } from 'react-intl';

export default function InventoryFilters({
  setQueryParams,
  queryParams,
}: ExtraFiltersProps<InventoryFilterProps>) {
  const intl = (message: string) => useIntl().formatMessage({ id: message });

  return (
    <Form>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={8} lg={4}>
          <OrderExtraFilter
            value={queryParams?.order}
            onChange={(values) =>
              setQueryParams((prev) => ({ ...prev, order: values }))
            }
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={6}>
          <CompaniesInfiniteSelectField
            onChange={(values) => {
              setQueryParams((prev) => ({ ...prev, companyId: values }));
            }}
            value={queryParams?.companyId}
            placeholder={intl('purchases.filters.company')}
            allowClear
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={4}>
          <DatePicker
            format="DD/MM/YYYY"
            style={{ width: '100%' }}
            value={queryParams?.date ? moment(queryParams?.date) : undefined}
            onChange={(value) =>
              setQueryParams((prev) => ({
                ...prev,
                date: value?.format('YYYY-MM-DD'),
              }))
            }
            placeholder={intl('inventory.columns.table.date')}
          />
        </Col>
        <Col xs={24} sm={24} md={16} lg={6}>
          <Select
            style={{ width: '100%' }}
            allowClear
            placeholder={intl('inventory.columns.table.inventoryReason')}
            onChange={(values) =>
              setQueryParams((prev) => ({ ...prev, reason: values }))
            }
            value={queryParams?.reason}
            options={getInventoryReasons().map(({ value, labelId }) => ({
              value,
              label: intl(labelId),
            }))}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={4}>
          <Select
            allowClear
            placeholder={intl('inventory.columns.table.situation')}
            options={getInventoryStatus().map(({ value, labelId }) => ({
              value,
              label: intl(labelId),
            }))}
            style={{ width: '100%' }}
            value={queryParams?.status}
            onChange={(values) =>
              setQueryParams((prev) => ({ ...prev, status: values }))
            }
          />
        </Col>
      </Row>
    </Form>
  );
}
